import { json } from 'helpers/data';
import moment from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Invoice {
    currency: string
    invoiceStatusId:number,
    invoiceTitle:string,
    serial: string,
    startDate: Date,
    invoiceStatus: number,
    total: number
}

interface Props {
    invoices?: Invoice[]
}

enum StatusColors {
    paid = 1,
    soon = 2,
    delayed = 3,
    unpaid = 4,
    canceled = 5
}

function InvoiceTable({invoices}: Props) {
    const { t } = useTranslation("home");

    return (
        <div className='invoice-table'>
            <table className='table'>
                <thead>
                <tr>
                    <th>{t("invoiceTable.invoice") as string}#</th>
                    <th>{t("invoiceTable.dueDate") as string}</th>
                    <th>{t("invoiceTable.status") as string}</th>
                    <th>{t("invoiceTable.amount") as string}</th>
                </tr>
                </thead>

                <tbody>
                {
                    invoices?.map(invoice => {
                        const status = StatusColors[invoice?.invoiceStatusId]
                        return (
                            <tr key={invoice?.serial}>
                                <td>{invoice?.serial?.slice(0,20)}{invoice?.serial?.length > 20 && '...'}</td>
                                <td>{moment(invoice.startDate).format('DD/MM/YYYY')}</td>
                                <td><span className={status}>{json(`${invoice.invoiceStatus}`)}</span></td>
                                <td>{invoice.total} {json(invoice.currency)} </td>
                            </tr>
                        )
                    })
                }
                </tbody>
            </table>
        </div>
    );
}


export default InvoiceTable;